import { RELAY_API_CONTENTFUL } from "@/utils/constant";

import {
    PricingPageRelayQuery,
    getPricingPageRelayQueryVars
} from "../../../contentful/graphql";
import { init as initRelay } from "../../../init-relay-streaming";
import { getPricingTitleInternal } from "../../../pages/software/jira/pricing/feature-gates";
import { JiraSoftwarePricingPage } from "../../../pages/software/jira/pricing/jira-software-pricing-page";

const pricingTitleInternal = getPricingTitleInternal();

initRelay(
    JiraSoftwarePricingPage,
    PricingPageRelayQuery,
    getPricingPageRelayQueryVars(
        "jira-software",
        window.location,
        pricingTitleInternal
    ),
    RELAY_API_CONTENTFUL
);
